import { Component } from '@angular/core';
import { CompanyDataService } from '../../../shared/company/company-data.service';

@Component({
  selector: 'track-by-demo',
  template: `
    <h2>
      Usage of track by for ngFor
    </h2>
    <ul>
      <li *ngFor="let option of options; trackById">
        {{option.name}}
      </li>
    </ul>
    
    <br />

    <ul>
      <li *ngFor="let option of options; trackByProp: 'id'">
        {{option.name}}
      </li>
    </ul>

    <br />

    <ul>
      <li *ngFor="let option of options; trackByProp: 'seq'">
        {{option.name}}
      </li>
    </ul>
	`,
  providers: [
    CompanyDataService
  ]
})
export class TrackByDemoComponent {
  public options = [
    { id: 12, seq: 1, name: 'Dr. Nice' },
    { id: 13, seq: 2, name: 'Bombasto' },
    { id: 14, seq: 3, name: 'Celeritas' },
    { id: 15, seq: 4, name: 'Magneta' },
    { id: 16, seq: 5, name: 'RubberMan' },
    { id: 17, seq: 6, name: 'Dynama' },
    { id: 18, seq: 7, name: 'Dr. IQ' },
    { id: 19, seq: 8, name: 'Magma' },
    { id: 20, seq: 9, name: 'Tornado' }
  ];
}